import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-field-help',
    templateUrl: './field-help.component.html',
    styleUrls: ['./field-help.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FieldHelpComponent {
  @Input() tooltip = '';
}
